import React from 'react';
import { oneOfType, number, string } from 'prop-types';
import _size from 'lodash/size';
import _filter from 'lodash/filter';
import _groupBy from 'lodash/groupBy';
import { useDesignStore } from '../../../store/design/context';

const ChoiceBundleQuantity = ({ choiceId, bundleSize }) => {
  const bundlesAdded = useDesignStore((state) => state.bundles.added);
  const groupedBundlesAdded = _groupBy(bundlesAdded, 'bundleChoiceId');
  const quantity = Math.floor(_size(groupedBundlesAdded?.[choiceId]) / bundleSize);

  if (!quantity) {
    return null;
  }

  return (
    <div
      className="custom-tile-quantity"
      style={{ textIndent: String(quantity).length === 1 ? '2.5rem' : '2rem' }}
    >
      {quantity}
    </div>
  );
};

ChoiceBundleQuantity.propTypes = {
  choiceId: oneOfType([number, string]).isRequired,
  bundleSize: number.isRequired
};

export default ChoiceBundleQuantity;
